import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BellOutline, Box, HStack, rem, Text } from '@bonusly/design-system';
import { useCurrentUser } from '@bonusly/who-am-i';

import { Reveal } from '../../../../components/display/reveal';
import { useFetchNotifications } from '../../../top-navbar/components/Notification/hooks/useFetchNotifications';

interface NotificationMenuItemProps {
	isExpanded: boolean;
	onClick: () => void;
}

export const NotificationMenuItem: FC<NotificationMenuItemProps> = ({ isExpanded, onClick }) => {
	const { t } = useTranslation('navigation');
	const user = useCurrentUser();
	const { unreadCount } = useFetchNotifications(user.locale);

	return (
		<Box
			as="a"
			display="block"
			onClick={onClick}
			w="100%"
			py={rem(8)}
			px={isExpanded ? rem(10) : rem(8)}
			borderRadius="md"
			bg="none"
			color="secondary.fg"
			cursor="pointer"
			_hover={{ bg: 'secondary.bgAlpha' }}
			_active={{ bg: 'secondary.bgAlpha' }}
			data-testid="nav-link-notifications"
		>
			<HStack justifyContent={isExpanded ? 'flex-start' : 'center'} alignItems="center" spacing={rem(12)}>
				<Box position="relative" display="flex" alignItems="center">
					<BellOutline size="md" />
				</Box>
				<Reveal if={isExpanded}>
					<HStack justifyContent="space-between" alignItems="center" width="100%">
						<Text fontSize={100} fontWeight="medium" whiteSpace="nowrap">
							{t('user_menu.notifications')}
						</Text>
						<Reveal if={unreadCount > 0}>
							<Box h={rem(22)} w={rem(22)} bg="error.bg" borderRadius="full" display="flex" justifyContent="center" alignItems="center">
								<Text color="error.text" fontSize={50} fontWeight="semibold" whiteSpace="nowrap" lineHeight={1}>
									{unreadCount > 99 ? '99+' : unreadCount}
								</Text>
							</Box>
						</Reveal>
					</HStack>
				</Reveal>
			</HStack>
		</Box>
	);
};
